import { useState, useEffect, useRef } from 'react';

/**
 * Componente para buscar endereço via Google Places Autocomplete
 * para ser usado em MapaAtual.
 */
function InputEndereco({ label, endereco, setEndereco, setPosicao }) {
  console.log('Entrou em InputEndereco, no componente....');

  const [sugestoes, setSugestoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const autocompleteServiceRef = useRef(null);
  const placesServiceRef = useRef(null);

  useEffect(() => {
    if (!window.google) {
      console.error("Google Maps JS não carregado. Verifique se o script está incluído no HTML.");
      return;
    }

    // Inicializa o serviço de autocomplete
    autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();

    // Serviço de detalhes para pegar lat/lng
    const mapDiv = document.createElement('div'); // apenas container vazio
    placesServiceRef.current = new window.google.maps.places.PlacesService(mapDiv);
  }, []);

  const buscarSugestoes = (texto) => {
    console.log('Entrou em buscarSugestoes... no InputEndereco.js...');

    if (!window.google) {
        console.warn("Google Maps JS ainda não carregado!");
        return;
    }

    if (!texto || !autocompleteServiceRef.current) {
      setSugestoes([]);
      return;
    }

    setLoading(true);
    autocompleteServiceRef.current.getPlacePredictions(
      {
        input: texto,
        types: ['establishment', 'geocode'], // lugares e endereços
        componentRestrictions: { country: 'br' },
      },
      (predictions, status) => {
        setLoading(false);
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          setSugestoes(predictions);
        } else {
          setSugestoes([]);
        }
      }
    );
  };

  const selecionarEndereco = (item) => {
    setEndereco(item.description);
    setSugestoes([]);

    if (!placesServiceRef.current) return;

    const request = {
      placeId: item.place_id,
      fields: ['geometry'],
    };

    placesServiceRef.current.getDetails(request, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place.geometry) {
        setPosicao([place.geometry.location.lat(), place.geometry.location.lng()]);
      }
    });
  };

  return (
    <div className="mb-3 position-relative">
      <label className="form-label">{label}</label>
      <input
        type="text"
        className="form-control"
        value={endereco}
        onChange={(e) => {
          setEndereco(e.target.value);
          buscarSugestoes(e.target.value);
        }}
        placeholder="Digite o endereço..."
      />
      {loading && <div>Buscando...</div>}

      {sugestoes.length > 0 && (
        <ul
          className="list-group position-absolute w-100"
          style={{ maxHeight: 200, overflowY: 'auto', zIndex: 1055 }}
        >
          {sugestoes.map((item, index) => (
            <li
              key={index}
              className="list-group-item list-group-item-action"
              onClick={() => selecionarEndereco(item)}
              style={{ cursor: 'pointer' }}
            >
              {item.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default InputEndereco;
